import React from "react";

const Card = ({ img, content, date, border = false }) => {
  return (
    <div
      className={`flex gap-2 items-center ${
        border ? "border border-gray-300" : ""
      } rounded-md relative mt-2`}
    >
      <img className="w-20" src={img} alt="" />
      <div className="flex-1">
        <p className="text-base font-semibold w-5/6">{content}</p>
        <small className="text-base">{date}</small>
      </div>
      {border && (
        <div className="absolute left-0 h-full w-3 bg-primary rounded-l-md "></div>
      )}
    </div>
  );
};

export default Card;
